import { unstable_ownerDocument as ownerDocument } from '@material-ui/utils';
export default ownerDocument;